import type { Theme } from '@mui/material';

import {
  Box,
  Divider,
  Checkbox,
  FormGroup,
  Typography,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';

import { Scrollbar } from 'src/components/scrollbar';

export const FormatFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const { filters, setFilters } = props;
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const handleChange = (value: string) => {
    const newFormat = filters.listing?.format === value ? null : value;

    setFilters((prev: any) => ({
      ...prev,
      listing: {
        format: newFormat,
      },
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Format
      </Typography>

      <Scrollbar sx={{ maxHeight: 164 }}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.listing?.format === 'faceToFace'}
                onChange={() => handleChange('faceToFace')}
                sx={{ py: 0.25 }}
              />
            }
            label="Yüzyüze"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.listing?.format === 'online'}
                onChange={() => handleChange('online')}
                sx={{ py: 0.25 }}
              />
            }
            label="Online"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters.listing?.format === 'preRecorded'}
                onChange={() => handleChange('preRecorded')}
                sx={{ py: 0.25 }}
              />
            }
            label="Önceden Kaydedilmiş"
          />
        </FormGroup>
      </Scrollbar>
    </Box>
  );
};
